import React, { useEffect, useRef } from 'react';

import { getComponentClasses } from '@99designs/common/utils/app';
import trackLink from '@99designs/common/utils/platform/trackLink';

export interface TrackedLinkProps {
    variations?: string[];
    event: { event: string; meta?: object };
    children: React.ReactNode;
    href: string;
}

function TrackedLink({ variations, event, ...props }: TrackedLinkProps) {
    const linkNode = useRef(null);

    useEffect(() => {
        trackLink(linkNode.current, event.event, event.meta);
    }, []);

    return <a ref={linkNode} className={getComponentClasses('link', variations)} {...props} />;
}

export default TrackedLink;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/messages/components/CircumventionWarningMessage/TrackedLink.tsx